import React, { useEffect, useMemo, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../i18n";

function Header() {
    const { lang, setLang, t } = useI18n();
    const [isGetStartedOpen, setIsGetStartedOpen] = useState(false);
    const [isMobileOpen, setIsMobileOpen] = useState(false);
    const [showParticipationModal, setShowParticipationModal] = useState(false);
    const [showRegistrationModal, setShowRegistrationModal] = useState(false);
    const [isAboutMobileOpen, setIsAboutMobileOpen] = useState(false);
    const [participationMode, setParticipationMode] = useState("");
    const [individualForm, setIndividualForm] = useState({
        danceType: "Folk",
        name: "",
        email: "",
        phone: "",
        gender: "",
        occupation: "",
    });
    const [groupCount, setGroupCount] = useState(1);
    const [groupForms, setGroupForms] = useState([{ fullName: "", email: "", phone: "", gender: "", occupation: "" }]);
    const [showSponsorshipModal, setShowSponsorshipModal] = useState(false);
    const [sponsorshipForm, setSponsorshipForm] = useState({
        fullName: "",
        email: "",
        address: "",
        occupation: "",
        idType: "Aadhaar",
        idNumber: "",
    });
    const [registrationForm, setRegistrationForm] = useState({
        fullName: "",
        email: "",
        phone: "",
        gender: "",
        occupation: "",
    });

    const danceTypes = useMemo(() => ["Folk", "Classical", "Modern", "Others"], []);

    const dropdownRef = useRef(null);

    useEffect(() => {
        function onDocumentClick(e) {
            if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
                setIsGetStartedOpen(false);
            }
        }
        if (isGetStartedOpen) {
            document.addEventListener("mousedown", onDocumentClick);
        } else {
            document.removeEventListener("mousedown", onDocumentClick);
        }
        return () => document.removeEventListener("mousedown", onDocumentClick);
    }, [isGetStartedOpen]);

    // Allow other pages to open registration modal via a custom event
    useEffect(() => {
        const onOpenRegistration = () => setShowRegistrationModal(true);
        window.addEventListener('open-registration', onOpenRegistration);
        return () => window.removeEventListener('open-registration', onOpenRegistration);
    }, []);

    const toggleGetStarted = (e) => {
        e.preventDefault();
        setIsGetStartedOpen((v) => !v);
    };

    const openParticipation = () => {
        setIsGetStartedOpen(false);
        setParticipationMode("");
        setShowParticipationModal(true);
    };
  


    const openSponsorship = () => {
        setIsGetStartedOpen(false);
        setShowSponsorshipModal(true);
    };

    const closeParticipation = () => {
        setShowParticipationModal(false);
        setParticipationMode("");
    };

    const handleIndividualChange = (e) => {
        const { name, value } = e.target;
        setIndividualForm((prev) => ({ ...prev, [name]: value }));
    };

    const handleGroupCountChange = (e) => {
        const value = Math.max(1, Math.min(20, Number(e.target.value) || 1));
        setGroupCount(value);
        setGroupForms((prev) => {
            const next = [...prev];
            if (value > next.length) {
                while (next.length < value) next.push({ fullName: "", email: "", phone: "", gender: "", occupation: "" });
            } else if (value < next.length) {
                next.length = value;
            }
            return next;
        });
    };

    const handleGroupFieldChange = (index, field, value) => {
        setGroupForms((prev) => {
            const next = [...prev];
            next[index] = { ...next[index], [field]: value };
            return next;
        });
    };

    const submitIndividual = (e) => {
        e.preventDefault();
        alert("Submitted Individual Participation");
        closeParticipation();
    };

    const submitGroup = (e) => {
        e.preventDefault();
        alert("Submitted Group Participation");
        closeParticipation();
    };

    const submitSponsorship = (e) => {
        e.preventDefault();
        alert("Thanks for your interest in Sponsorship!");
        setShowSponsorshipModal(false);
    };
    const API_BASE = (() => {
        // Prefer explicit env override
        if (process.env.REACT_APP_API_BASE) return process.env.REACT_APP_API_BASE;
        
        if (typeof window !== 'undefined') {
            const { hostname, protocol, pathname } = window.location;
            
            // Check if we're on localhost (development)
            if (hostname === 'localhost' || hostname === '127.0.0.1') {
                return `${protocol}//${hostname}/konark`;
            }
            
            // Production server - use the current domain
            // Remove any existing path and use the root
            const baseUrl = `${protocol}//${hostname}`;
            
            // If there's a path, use it as the base
            if (pathname && pathname !== '/') {
                const pathParts = pathname.split('/').filter(p => p);
                if (pathParts.length > 0) {
                    return `${baseUrl}/${pathParts[0]}`;
                }
            }
            
            return baseUrl;
        }
        return "";
    })();

    async function postJsonWithFallback(paths, payload) {
        let lastErr;
        for (const p of paths) {
            try {
                console.log('Trying endpoint:', p);
                const res = await fetch(p, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) });
                const data = await res.json().catch(() => ({}));
                console.log('Response:', res.status, data);
                if (res.ok && data && (data.ok === true || data.ok === undefined)) {
                    return { res, data };
                }
                lastErr = data && (data.error || data.details) ? (data.error + (data.details ? `: ${data.details}` : '')) : `HTTP ${res.status}`;
            } catch (e) {
                console.error('Fetch error for', p, ':', e);
                lastErr = String(e && e.message || e);
            }
        }
        throw new Error(lastErr || 'Request failed');
    }

    return (

        <>
            <style>{`
            /* Scoped styles for Header modals */
            .kf-themed-card { background:#0f3a3a; border-radius:20px; padding:28px; }
            .kf-themed-title { color:#e9f7f7; font-weight:700; font-size:34px; margin:0 0 22px; }
            .kf-form .form-control { background:#264a4a; color:#e6f4f4; border:0; height:56px; border-radius:12px; padding:12px 16px; appearance:none; -webkit-appearance:none; -moz-appearance:none; line-height:1.3; }
            .kf-form select.form-control { background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="%23c7dbdb" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>'); background-repeat:no-repeat; background-position: right 14px center; padding-right:42px; position:relative; z-index:2; }
            .kf-form textarea.form-control { height:140px; resize:vertical; }
            .kf-form .form-control:focus { outline:none; box-shadow:0 0 0 3px rgba(255,255,255,0.08); }
            .kf-form .form-control::placeholder { color:#c7dbdb; opacity:1; }
            .kf-submit { width:100%; background:#f2b52a; color:#0f3a3a; border:0; height:56px; border-radius:12px; font-weight:600; }
            .modal-content.kf-modal { border:0; border-radius:20px; overflow:visible; background:#080808; position:relative; }
            .modal-header.kf-modal-h { background:transparent; border-bottom:0; padding:16px 16px 0 16px; display:flex; align-items:center; justify-content:space-between; }
            .kf-close { position:absolute; top:8px; right:10px; color:#ffffff; opacity:0.9; }
            .dropdown-menu.show.kf-dropdown { backdrop-filter:saturate(140%) blur(6px); }
            /* Mobile nav */
            .kf-hamburger { display:none; width:40px; height:40px; align-items:center; justify-content:center; border:1px solid rgba(255,255,255,0.3); border-radius:8px; }
            .kf-hamburger span { display:block; width:20px; height:2px; background:#fff; position:relative; }
            .kf-hamburger span::before, .kf-hamburger span::after { content:""; position:absolute; left:0; width:20px; height:2px; background:#fff; }
            .kf-hamburger span::before { top:-6px; }
            .kf-hamburger span::after { top:6px; }
            .kf-mobile-overlay { position:fixed; inset:0; background:rgba(0,0,0,0.55); z-index:1050; }
            .kf-mobile-drawer { position:fixed; top:0; right:0; height:100%; width:82%; max-width:360px; background:#0f3a3a; z-index:1060; transform:translateX(100%); transition:transform .25s ease; padding:18px 16px; box-shadow:-8px 0 24px rgba(0,0,0,0.3); }
            .kf-mobile-drawer.open { transform:translateX(0); }
            .kf-mobile-link { display:block; color:#179292; padding:12px 8px; border-bottom:1px solid rgba(255,255,255,0.08); }
            .kf-mobile-section-title { color:#c7dbdb; font-weight:700; margin:12px 8px 6px; font-size:13px; text-transform:uppercase; letter-spacing:.08em; }
            @media (max-width: 991px) {
              .main-header .main-menu { display:none; }
              .kf-hamburger { display:flex; }
            }
            `}</style>
            <header className="main-header">
                <div className="header-sticky bg-section">
                    <nav className="navbar navbar-expand-lg">
                        <div className="container">
                            {/* Logo Start */}
                            <Link className="navbar-brand" to="/">
                                <img src="images/Konark Logo.png" alt="Logo" />
                            </Link>
                            {/* Logo End */}
                            {/* Main Menu Start */}
                            <div className="collapse navbar-collapse main-menu">
                                <div className="nav-menu-wrapper">
                                    <ul className="navbar-nav mr-auto" id="menu">
                                        <li className="nav-item ">
                                            <Link className="nav-link" to="/">
                                                {t('nav.home')}
                                            </Link>

                                        </li>
                                        <li className="nav-item submenu">
                                            <Link className="nav-link" to="/About">
                                                {t('nav.about')}
                                            </Link>

                                            <ul>
                                                <li className="nav-item">
                                                    <Link className="nav-link" to="/History">History</Link>
                                                </li>
                                                <li className="nav-item">
                                                    <Link className="nav-link" to="/Team">Management Team</Link>
                                                </li>
                                               
                                                <li className="nav-item">
                                                    <Link className="nav-link" to="/SimilarFestival">Similar Festival</Link>
                                                </li>
                                            </ul>
                                        </li >

                                        <li className="nav-item">
                                            <Link className="nav-link" to="/Event">
                                                {t('nav.event')}
                                            </Link>
                                        </li >


                                        <li className="nav-item">
                                            <Link className="nav-link" to="/Contact">
                                                {t('nav.contact')}
                                            </Link>
                                        </li>


                                        <li className="nav-item submenu"><a className="nav-link" href="#">{t('nav.media')}</a>
                                            <ul>
                                                <li className="nav-item">
                                                    <Link className="nav-link" to="/image-gallery">{t('nav.imageGallery')}</Link>
                                                </li>
                                                <li className="nav-item">
                                                    <Link className="nav-link" to="/video-gallery">{t('nav.videoGallery')}</Link>
                                                </li>

                                            </ul>
                                        </li>
                                    </ul>
                                </div>

                                
                                {/* Header Btn Start */}
                                <div className="header-btn" style={{ position: "relative", display: "flex", gap: 12, alignItems: 'center' }} ref={dropdownRef}>
                                    <a href="" className="btn-default btn-highlighted" onClick={(e) => { e.preventDefault(); setIsGetStartedOpen((v) => !v); }}>
                                        {t('header.participation')}
                                    </a>
                                    {isGetStartedOpen && (
                                        <div className="dropdown-menu show kf-dropdown" style={{ display: "block", minWidth: 240, padding: 8, borderRadius: 10, boxShadow: "0 8px 24px rgba(0,0,0,0.25)", position: "absolute", right: 0, top: "110%", background: "rgba(255,255,255,0.95)" }}>
                                            <button className="dropdown-item" style={{ padding: "10px 12px", borderRadius: 6 }} onClick={() => { setIsGetStartedOpen(false); setShowParticipationModal(true); setParticipationMode(""); }}>{t('header.danceParticipation')}</button>
                                            <button className="dropdown-item" style={{ padding: "10px 12px", borderRadius: 6 }} onClick={openSponsorship}>{t('header.sponsorship')}</button>
                                        </div>
                                    )}
                                    <a href="" className="btn-default" onClick={(e) => { e.preventDefault(); setShowRegistrationModal(true); setIsGetStartedOpen(false); }}>
                                        {t('header.registration')}
                                    </a>
                                    <select aria-label="Select language" value={lang} onChange={(e) => setLang(e.target.value)} style={{ height: 36, borderRadius: 6, background: '#264a4a', color: '#e6f4f4', border: 0, padding: '6px 10px' }}>
                                        <option value="en">EN</option>
                                        <option value="hi">HI</option>
                                        <option value="or">OR</option>
                                    </select>
                                </div>
                                {/* Header Btn End */}
                            </div>
                            {/* Main Menu End */}
                            <button className="navbar-toggle kf-hamburger" onClick={() => setIsMobileOpen(true)} aria-label="Open menu">
                                <span />
                            </button>
                        </div>
                    </nav>
                    <div className="responsive-menu" />
                </div>
            </header>

            {/* Mobile Drawer */}
            {isMobileOpen && (
                <div>
                    <div className="kf-mobile-overlay" onClick={() => setIsMobileOpen(false)} />
                    <div className={`kf-mobile-drawer ${isMobileOpen ? 'open' : ''}`} role="dialog" aria-modal="true">
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
                            <img src="images/Konark Logo.png" alt="Logo" style={{ height: 36 }} />
                            <button className="close" onClick={() => setIsMobileOpen(false)} aria-label="Close" style={{ color: '#e9f7f7', opacity: 1, fontSize: 28, lineHeight: 1 }}>×</button>
                        </div>
                        <Link to="/" className="kf-mobile-link" onClick={() => setIsMobileOpen(false)}>{t('nav.home')}</Link>
                        <button className="kf-mobile-link" onClick={() => setIsAboutMobileOpen(v => !v)}>{t('nav.about')} {isAboutMobileOpen ? '▾' : '▸'}</button>
                        {isAboutMobileOpen && (
                            <div style={{ paddingLeft: 12 }}>
                                <Link to="/History" className="kf-mobile-link" onClick={() => setIsMobileOpen(false)}>History</Link>
                                <Link to="/Team" className="kf-mobile-link" onClick={() => setIsMobileOpen(false)}>Management Team</Link>
                                <Link to="/SimilarFestival" className="kf-mobile-link" onClick={() => setIsMobileOpen(false)}>Similar Festival</Link>
                            </div>
                        )}
                        <Link to="/Contact" className="kf-mobile-link" onClick={() => setIsMobileOpen(false)}>{t('nav.contact')}</Link>
                        <div className="kf-mobile-section-title">{t('nav.media')}</div>
                        <Link to="/image-gallery" className="kf-mobile-link" onClick={() => setIsMobileOpen(false)}>{t('nav.imageGallery')}</Link>
                        <Link to="/video-gallery" className="kf-mobile-link" onClick={() => setIsMobileOpen(false)}>{t('nav.videoGallery')}</Link>
                        <div className="kf-mobile-section-title">{t('header.getStarted')}</div>
                        <button className="kf-mobile-link" onClick={() => { setIsMobileOpen(false); setShowParticipationModal(true); setParticipationMode(""); }}>{t('header.danceParticipation')}</button>
                        <button className="kf-mobile-link" onClick={() => { setIsMobileOpen(false); setShowRegistrationModal(true); }}>{t('header.registerYourParticipation')}</button>
                        <button className="kf-mobile-link" onClick={() => { setIsMobileOpen(false); openSponsorship(); }}>{t('header.sponsorship')}</button>
                        <div style={{ display: 'flex', alignItems: 'center', padding: '12px 8px' }}>
                            <span style={{ color: '#c7dbdb', marginRight: 8 }}>Language:</span>
                            <select aria-label="Select language" value={lang} onChange={(e) => setLang(e.target.value)} style={{ height: 36, borderRadius: 6, background: '#264a4a', color: '#e6f4f4', border: 0, padding: '6px 10px' }}>
                                <option value="en">EN</option>
                                <option value="hi">HI</option>
                                <option value="or">OR</option>
                            </select>
                        </div>
                    </div>
                </div>
            )}

            {showParticipationModal && (
                <div>
                    <div className="modal d-block" tabIndex="-1" role="dialog" style={{ background: "rgba(0,0,0,0.55)" }} onClick={() => setShowParticipationModal(false)}>
                        <div className="modal-dialog modal-lg" role="document" onClick={(e) => e.stopPropagation()}>
                            <div className="modal-content kf-modal">
                                <div className="modal-header kf-modal-h">
                                    <h5 className="modal-title kf-themed-title">{t('header.registerHere')}</h5>
                                    <button type="button" className="close kf-close" onClick={() => setShowParticipationModal(false)} aria-label="Close">
                                        <span aria-hidden="true">×</span>
                                    </button>
                                </div>
                                <div className="modal-body" style={{ padding: 16 }}>
                                    <div className="kf-themed-card">
                                        {!participationMode && (
                                            <div className="row">
                                                <div className="col-md-6 mb-3">
                                                    <button className="btn-default btn-highlighted w-100" style={{ padding: "12px 18px", borderRadius: 8 }} onClick={() => setParticipationMode("individual")}>
                                                        {t('labels.individualPerformance')}
                                                    </button>
                                                </div>
                                                <div className="col-md-6 mb-3">
                                                    <button className="btn-default w-100" style={{ padding: "12px 18px", borderRadius: 8 }} onClick={() => setParticipationMode("group")}>
                                                        {t('labels.groupPerformance')}
                                                    </button>
                                                </div>
                                            </div>
                                        )}

                                        {participationMode === "individual" && (
                                            <div className="contact-form kf-form">
                                                <form onSubmit={async (e) => {
                                                    e.preventDefault();
                                                    try {
                                                        const payload = {
                                                            danceType: individualForm.danceType,
                                                            name: individualForm.name,
                                                            email: individualForm.email,
                                                            phone: individualForm.phone,
                                                            gender: individualForm.gender,
                                                            occupation: individualForm.occupation,
                                                        };
                                                        const { data } = await postJsonWithFallback([
                                                            `${API_BASE}/api/participation_individual.php`,
                                                            `${API_BASE}/public/api/participation_individual.php`,
                                                        ], payload);
                                                        if (!data || data.ok !== true) throw new Error((data && (data.error || data.details)) || 'Failed');
                                                        alert(data.message || 'Submitted Individual Participation');
                                                        setShowParticipationModal(false);
                                                    } catch (err) {
                                                        alert(`Error submitting individual participation: ${String(err && err.message || err)}`);
                                                    }
                                                }} className="wow fadeInUp" data-wow-delay="0.2s">
                                                    <div className="row">
                                                        <div className="form-group col-md-6 mb-4">
                                                            <label>{t('labels.danceType')}</label>
                                                            <select name="danceType" className="form-control" style={{ height: 58, borderRadius: 8 }} value={individualForm.danceType} onChange={(e) => setIndividualForm((p) => ({ ...p, danceType: e.target.value }))}>
                                                                {danceTypes.map((t) => (
                                                                    <option key={t} value={t}>{t}</option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                        <div className="form-group col-md-6 mb-4">
                                                            <label>{t('labels.fullName')}</label>
                                                            <input type="text" name="name" className="form-control" style={{ height: 48, borderRadius: 8 }} placeholder="Full name" required value={individualForm.name} onChange={(e) => setIndividualForm((p) => ({ ...p, name: e.target.value }))} />
                                                        </div>
                                                        <div className="form-group col-md-6 mb-4">
                                                            <label>{t('labels.email')}</label>
                                                            <input type="email" name="email" className="form-control" style={{ height: 48, borderRadius: 8 }} placeholder="E-mail" required value={individualForm.email} onChange={(e) => setIndividualForm((p) => ({ ...p, email: e.target.value }))} />
                                                        </div>
                                                        <div className="form-group col-md-6 mb-4">
                                                            <label>{t('labels.phone_short')}</label>
                                                            <input type="text" name="phone" className="form-control" style={{ height: 48, borderRadius: 8 }} placeholder="Phone" required value={individualForm.phone} onChange={(e) => setIndividualForm((p) => ({ ...p, phone: e.target.value }))} />
                                                        </div>
                                                        <div className="form-group col-md-6 mb-4">
                                                            <label>{t('labels.gender')}</label>
                                                            <select name="gender" className="form-control" style={{ height: 58, borderRadius: 8 }} required value={individualForm.gender} onChange={(e) => setIndividualForm((p) => ({ ...p, gender: e.target.value }))}>
                                                                <option value="">{t('labels.selectGender')}</option>
                                                                <option value="Male">{t('labels.male')}</option>
                                                                <option value="Female">{t('labels.female')}</option>
                                                                <option value="Other">{t('labels.other')}</option>
                                                            </select>
                                                        </div>
                                                        <div className="form-group col-md-6 mb-4">
                                                            <label>{t('labels.occupation')}</label>
                                                            <input type="text" name="occupation" className="form-control" style={{ height: 58, borderRadius: 8 }} placeholder="Occupation" required value={individualForm.occupation} onChange={(e) => setIndividualForm((p) => ({ ...p, occupation: e.target.value }))} />
                                                        </div>
                                                        <div className="col-md-12">
                                                            <button type="submit" className="kf-submit">{t('labels.sendMessage')}</button>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        )}

                                        {participationMode === "group" && (
                                            <div className="contact-form kf-form">
                                                <form onSubmit={async (e) => {
                                                    e.preventDefault();
                                                    try {
                                                        const payload = {
                                                            danceType: individualForm.danceType,
                                                            count: groupCount,
                                                            participants: groupForms,
                                                        };
                                                        const { data } = await postJsonWithFallback([
                                                            `${API_BASE}/api/participation_group.php`,
                                                            `${API_BASE}/public/api/participation_group.php`,
                                                        ], payload);
                                                        if (!data || data.ok !== true) throw new Error((data && (data.error || data.details)) || 'Failed');
                                                        alert(data.message || 'Submitted Group Participation');
                                                        setShowParticipationModal(false);
                                                    } catch (err) {
                                                        alert(`Error submitting group participation: ${String(err && err.message || err)}`);
                                                    }
                                                }} className="wow fadeInUp" data-wow-delay="0.2s">
                                                    <div className="row">
                                                        <div className="form-group col-md-6 mb-4">
                                                            <label>{t('labels.numberOfParticipants')}</label>
                                                            <input type="number" min="1" max="20" className="form-control" style={{ height: 48, borderRadius: 8 }} value={groupCount} onChange={(e) => {
                                                                const value = Math.max(1, Math.min(20, Number(e.target.value) || 1));
                                                                setGroupCount(value);
                                                                setGroupForms((prev) => {
                                                                    const next = [...prev];
                                                                    if (value > next.length) {
                                                                        while (next.length < value) next.push({ fullName: "", email: "", phone: "", gender: "", occupation: "" });
                                                                    } else if (value < next.length) {
                                                                        next.length = value;
                                                                    }
                                                                    return next;
                                                                });
                                                            }} />
                                                        </div>
                                                        <div className="form-group col-md-6 mb-4">
                                                            <label>{t('labels.danceType')}</label>
                                                            <select className="form-control" style={{ height: 58, borderRadius: 8 }} onChange={(e) => setIndividualForm((p) => ({ ...p, danceType: e.target.value }))} value={individualForm.danceType}>
                                                                {danceTypes.map((t) => (
                                                                    <option key={t} value={t}>{t}</option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                        <div className="col-md-12">
                                                            {groupForms.map((p, idx) => (
                                                                <div key={idx} className="row" style={{ border: "1px solid #eee", borderRadius: 6, padding: 12, marginBottom: 16 }}>
                                                                    <div className="col-12 mb-2"><strong>Participant {idx + 1}</strong></div>
                                                                    <div className="form-group col-md-6 mb-4">
                                                                        <label>{t('labels.fullName')}</label>
                                                                        <input type="text" className="form-control" style={{ height: 48, borderRadius: 8 }} placeholder="Full name" required value={p.fullName} onChange={(e) => {
                                                                            const value = e.target.value;
                                                                            setGroupForms((prev) => { const next = [...prev]; next[idx] = { ...next[idx], fullName: value }; return next; });
                                                                        }} />
                                                                    </div>
                                                                    <div className="form-group col-md-6 mb-4">
                                                                        <label>{t('labels.email')}</label>
                                                                        <input type="email" className="form-control" style={{ height: 48, borderRadius: 8 }} placeholder="E-mail" required value={p.email} onChange={(e) => {
                                                                            const value = e.target.value;
                                                                            setGroupForms((prev) => { const next = [...prev]; next[idx] = { ...next[idx], email: value }; return next; });
                                                                        }} />
                                                                    </div>
                                                                    <div className="form-group col-md-4 mb-4">
                                                                        <label>{t('labels.phone_short')}</label>
                                                                        <input type="text" className="form-control" style={{ height: 48, borderRadius: 8 }} placeholder="Phone" required value={p.phone} onChange={(e) => {
                                                                            const value = e.target.value;
                                                                            setGroupForms((prev) => { const next = [...prev]; next[idx] = { ...next[idx], phone: value }; return next; });
                                                                        }} />
                                                                    </div>
                                                                    <div className="form-group col-md-4 mb-4">
                                                                        <label>{t('labels.gender')}</label>
                                                                        <select className="form-control" style={{ height: 58, borderRadius: 8 }} required value={p.gender} onChange={(e) => {
                                                                            const value = e.target.value;
                                                                            setGroupForms((prev) => { const next = [...prev]; next[idx] = { ...next[idx], gender: value }; return next; });
                                                                        }}>
                                                                            <option value="">{t('labels.selectGender')}</option>
                                                                            <option value="Male">{t('labels.male')}</option>
                                                                            <option value="Female">{t('labels.female')}</option>
                                                                            <option value="Other">{t('labels.other')}</option>
                                                                        </select>
                                                                    </div>
                                                                    <div className="form-group col-md-4 mb-4">
                                                                        <label>{t('labels.occupation')}</label>
                                                                        <input type="text" className="form-control" style={{ height: 48, borderRadius: 8 }} placeholder="Occupation" required value={p.occupation} onChange={(e) => {
                                                                            const value = e.target.value;
                                                                            setGroupForms((prev) => { const next = [...prev]; next[idx] = { ...next[idx], occupation: value }; return next; });
                                                                        }} />
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                        <div className="col-md-12">
                                                            <button type="submit" className="kf-submit">{t('labels.sendMessage')}</button>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {showSponsorshipModal && (
                <div>
                    <div className="modal d-block" tabIndex="-1" role="dialog" style={{ background: "rgba(0,0,0,0.55)" }} onClick={() => setShowSponsorshipModal(false)}>
                        <div className="modal-dialog" role="document" onClick={(e) => e.stopPropagation()}>
                            <div className="modal-content kf-modal">
                                <div className="modal-header kf-modal-h">
                                    <h5 className="modal-title kf-themed-title">Get in touch with us</h5>
                                    <button type="button" className="close kf-close" onClick={() => setShowSponsorshipModal(false)} aria-label="Close">
                                        <span aria-hidden="true">×</span>
                                    </button>
                                </div>
                                <div className="modal-body" style={{ padding: 16 }}>
                                    <div className="contact-form kf-form kf-themed-card">
                                        <form onSubmit={async (e) => {
                                            e.preventDefault();
                                            try {
                                                const form = new FormData();
                                                form.append("fullName", sponsorshipForm.fullName);
                                                form.append("email", sponsorshipForm.email);
                                                form.append("address", sponsorshipForm.address);
                                                form.append("occupation", sponsorshipForm.occupation);
                                                form.append("idType", sponsorshipForm.idType);
                                                form.append("idNumber", sponsorshipForm.idNumber);
                                                if (sponsorshipForm.documentFile) form.append("document", sponsorshipForm.documentFile);
                                                // Try both endpoints for broader compatibility
                                                const endpoints = [
                                                    `${API_BASE}/api/sponsorship.php`,
                                                    `${API_BASE}/public/api/sponsorship.php`,
                                                ];
                                                let data;
                                                let lastErr;
                                                for (const ep of endpoints) {
                                                    try {
                                                        const res = await fetch(ep, { method: "POST", body: form });
                                                        data = await res.json().catch(() => ({}));
                                                        if (res.ok && data && (data.ok === true || data.ok === undefined)) {
                                                            break;
                                                        }
                                                        lastErr = data && (data.error || data.details) ? (data.error + (data.details ? `: ${data.details}` : '')) : `HTTP ${res.status}`;
                                                    } catch (e) {
                                                        lastErr = String(e && e.message || e);
                                                    }
                                                }
                                                if (!data || data.ok !== true) throw new Error(lastErr || 'Failed');
                                                alert(data.message || 'Sponsorship submitted');
                                                setShowSponsorshipModal(false);
                                            } catch (err) {
                                                alert(`Error submitting sponsorship: ${String(err && err.message || err)}`);
                                            }
                                        }} className="wow fadeInUp" data-wow-delay="0.2s">
                                            <div className="row">
                                                <div className="form-group col-md-6 mb-4">
                                                    <label>{t('labels.fullName')}</label>
                                                    <input type="text" className="form-control" style={{ height: 48, borderRadius: 8 }} placeholder="Full name" required value={sponsorshipForm.fullName} onChange={(e) => setSponsorshipForm((p) => ({ ...p, fullName: e.target.value }))} />
                                                </div>
                                                <div className="form-group col-md-6 mb-4">
                                                    <label>{t('labels.email')}</label>
                                                    <input type="email" className="form-control" style={{ height: 48, borderRadius: 8 }} placeholder="E-mail" required value={sponsorshipForm.email} onChange={(e) => setSponsorshipForm((p) => ({ ...p, email: e.target.value }))} />
                                                </div>
                                                <div className="form-group col-md-12 mb-4">
                                                    <label>{t('labels.address')}</label>
                                                    <input type="text" className="form-control" style={{ height: 48, borderRadius: 8 }} placeholder="Address" required value={sponsorshipForm.address} onChange={(e) => setSponsorshipForm((p) => ({ ...p, address: e.target.value }))} />
                                                </div>
                                                <div className="form-group col-md-6 mb-4">
                                                    <label>{t('labels.occupation')}</label>
                                                    <input type="text" className="form-control" style={{ height: 48, borderRadius: 8 }} placeholder="Occupation" required value={sponsorshipForm.occupation} onChange={(e) => setSponsorshipForm((p) => ({ ...p, occupation: e.target.value }))} />
                                                </div>
                                                <div className="form-group col-md-6 mb-4">
                                                    <label>{t('labels.idType')}</label>
                                                    <select className="form-control" style={{ height: 48, borderRadius: 8 }} value={sponsorshipForm.idType} onChange={(e) => setSponsorshipForm((p) => ({ ...p, idType: e.target.value }))}>
                                                        <option value="Aadhaar">Aadhaar</option>
                                                        <option value="PAN">PAN</option>
                                                    </select>
                                                </div>
                                                <div className="form-group col-md-12 mb-4">
                                                    <label>{t('labels.idNumber')}</label>
                                                    <input type="text" className="form-control" style={{ height: 48, borderRadius: 8 }} placeholder={`${sponsorshipForm.idType} Number`} required value={sponsorshipForm.idNumber} onChange={(e) => setSponsorshipForm((p) => ({ ...p, idNumber: e.target.value }))} />
                                                </div>
                                                <div className="form-group col-md-12 mb-4">
                                                    <label>{t('labels.upload')} {sponsorshipForm.idType} Image</label>
                                                    <input type="file" accept="image/*" className="form-control" style={{ height: 56, borderRadius: 8, background: '#264a4a' }} onChange={(e) => setSponsorshipForm((p) => ({ ...p, documentFile: e.target.files && e.target.files[0] }))} />
                                                </div>
                                                <div className="col-md-12">
                                                    <button type="submit" className="kf-submit">{t('labels.sendMessage')}</button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {showRegistrationModal && (
                <div>
                    <div className="modal d-block" tabIndex="-1" role="dialog" style={{ background: "rgba(0,0,0,0.55)" }} onClick={() => setShowRegistrationModal(false)}>
                        <div className="modal-dialog modal-lg" role="document" onClick={(e) => e.stopPropagation()}>
                            <div className="modal-content kf-modal">
                                <div className="modal-header kf-modal-h">
                                    <h5 className="modal-title kf-themed-title">{t('header.registration')}</h5>
                                    <button type="button" className="close kf-close" onClick={() => setShowRegistrationModal(false)} aria-label="Close">
                                        <span aria-hidden="true">×</span>
                                    </button>
                                </div>
                                <div className="modal-body" style={{ padding: 16 }}>
                                    <div className="contact-form kf-form kf-themed-card">
                                        <form onSubmit={async (e) => {
                                            e.preventDefault();
                                            try {
                                                const payload = {
                                                    fullName: registrationForm.fullName,
                                                    email: registrationForm.email,
                                                    phone: registrationForm.phone,
                                                    gender: registrationForm.gender,
                                                    occupation: registrationForm.occupation,
                                                };
                                                const { data } = await postJsonWithFallback([
                                                    `${API_BASE}/api/registration.php`,
                                                    `${API_BASE}/public/api/registration.php`,
                                                    `${API_BASE}/public/api/test.php`,
                                                ], payload);
                                                if (!data || data.ok !== true) throw new Error((data && (data.error || data.details)) || 'Failed');
                                                alert(data.message || 'Registration submitted');
                                                setShowRegistrationModal(false);
                                                setRegistrationForm({ fullName: '', email: '', phone: '', gender: '', occupation: '' });
                                            } catch (err) {
                                                alert(`Error submitting registration: ${String(err && err.message || err)}`);
                                            }
                                        }} className="wow fadeInUp" data-wow-delay="0.2s">
                                            <div className="row">
                                                <div className="form-group col-md-6 mb-4">
                                                    <label>{t('labels.fullName')}</label>
                                                    <input type="text" className="form-control" style={{ height: 48, borderRadius: 8 }} placeholder="Full name" required value={registrationForm.fullName} onChange={(e) => setRegistrationForm((p) => ({ ...p, fullName: e.target.value }))} />
                                                </div>
                                                <div className="form-group col-md-6 mb-4">
                                                    <label>{t('labels.email')}</label>
                                                    <input type="email" className="form-control" style={{ height: 48, borderRadius: 8 }} placeholder="E-mail" required value={registrationForm.email} onChange={(e) => setRegistrationForm((p) => ({ ...p, email: e.target.value }))} />
                                                </div>
                                                <div className="form-group col-md-6 mb-4">
                                                    <label>{t('labels.phone')}</label>
                                                    <input type="text" className="form-control" style={{ height: 48, borderRadius: 8 }} placeholder="Phone" required value={registrationForm.phone} onChange={(e) => setRegistrationForm((p) => ({ ...p, phone: e.target.value }))} />
                                                </div>
                                                <div className="form-group col-md-6 mb-4">
                                                    <label>{t('labels.gender')}</label>
                                                    <select className="form-control" style={{ height: 58, borderRadius: 8 }} required value={registrationForm.gender} onChange={(e) => setRegistrationForm((p) => ({ ...p, gender: e.target.value }))}>
                                                        <option value="">{t('labels.selectGender')}</option>
                                                        <option value="Male">{t('labels.male')}</option>
                                                        <option value="Female">{t('labels.female')}</option>
                                                        <option value="Other">{t('labels.other')}</option>
                                                    </select>
                                                </div>
                                                <div className="form-group col-md-12 mb-4">
                                                    <label>{t('labels.occupation')}</label>
                                                    <input type="text" className="form-control" style={{ height: 58, borderRadius: 8 }} placeholder="Occupation" required value={registrationForm.occupation} onChange={(e) => setRegistrationForm((p) => ({ ...p, occupation: e.target.value }))} />
                                                </div>
                                                <div className="col-md-12">
                                                    <button type="submit" className="kf-submit">{t('labels.sendMessage')}</button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

export default Header;